module.exports = __webpack_public_path__ + "img/img1.7b9541e7.jpg";